export type Duration = 'day' | 'week' | 'month';

// export class SelectionEvent {
//     startDate: Date;
//     duration: Duration;
//     machine: string;
//     constructor(startDate: Date, duration: Duration, machine: string) {
//         this.startDate = startDate;
//         this.duration = duration;
//         this.machine = machine;
//     }
// }

export class DashSelection {
    startDate: Date;
    duration: Duration;
    machine: string;
    constructor(startDate: Date, duration: Duration, machine: string) {
        this.startDate = startDate;
        this.duration = duration;
        this.machine = machine;
    }
}